import { render, staticRenderFns } from "./modal2.vue?vue&type=template&id=5bd29b94"
import script from "./modal2.vue?vue&type=script&lang=js"
export * from "./modal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports